import axios from "@/plugins/axios";

import contact from "./contact";
import files from "./files";

let url = "/api/v1/users";
export default {
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },

    checkUsername: {
        post(data) {
            return axios.post(`${url}/check-username`, data).then((result) => result.data);
        },
    },

    certify: {
        post(data) {
            return axios.post(`${url}/certify`, data).then((result) => result.data);
        },
    },
    recovery: {
        post(data) {
            return axios.post(`${url}/recovery`, data).then((result) => result.data);
        },
    },

    contact,
    files,
};
